import request from '@/util/request'

//固件管理列表
export function GetFirmList(data){
    return request({
        url:`/order-s/order/firmware/list`,
        method:'get',
        params:data
    })
}
//批量删除
export function DelFirmList(data){
    return request({
        url:`/order-s/order/firmware/list/delete`,
        method:'post',
        data
    })
}
//固件管理详情
export function GetFirmDetail(id,language){
    return request({
        url:`/order-s/order/firmware/${id}/${language}`,
        method:'get'
    })
}
//固件详情内列表
export function GetActionRecords(data){
    return request({
        url:`/order-s/order/action/upgradeRecords`,
        method:'post',
        data
    })
}

//固件包下拉列表查询接口
export function orderFirmwareListCode(productKey) { 
	return request({
		url: `/order-s/order/firmware/listName/${productKey}`,
		method: 'get'
	});
}

//获取当前组织下产品列表
export function GetCompanyList(params){
    return request({
        url:`/product-s/product/map`,
        method:'get',
        params
    })
}

//根据产品key获取版本参数信息
export function GetProSelect(data){
    return request({
        url:`/product-s/product/param/version`,
        method:'post',
        data
    })
}
//上传固件[上传]
export function SaveFirmwareUpdate(param,data){
    return request({
        url:`/order-s/order/firmware/save/update`,
        method:'formdata',
        params:param,
        data
    })
}
//上传固件[更新]
export function SaveFirmwareUpload(param,data){
    return request({
        url:`/order-s/order/firmware/save/upload`,
        method:'formdata',
        params:param,
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/device/firmware.js